<template>
    <div class="container-fluid thankyou-fancy">
        <div class="content text-center p-5">
            <img src="@/assets/images/ah-thanks.svg" alt="Icono de gracias"/>
            <h1>¡Gracias por registrarte!</h1>
            <p>Te mantendremos al tanto del lanzamiento de GinnyApp</p>
        </div>
    </div>
</template>
<script>
    export default {
        name: "ThankYouModal",
        mounted() {
            window.fbq('track', 'CompleteRegistration');
            setTimeout(() => {
                this.$modal.hide('sign-up-modal');
            }, 3000);
        }
    }
</script>
<style lang="scss" scoped>
.thankyou-fancy {
    margin-top: 2em;
    margin-bottom: 2em;
    position: relative;
    border-radius: 1em;

    .content {
        h1 {
            font-size: $large-font-size;
            font-family: $primary-font;
            color: $primary-color;
        }

        p {
            font-size: $small-font-size;
        }
    }
}
</style>